<template>
  <div
    class="flex_box"
    :style="styleMerge"
  >
    <div class="current-active" />
    <div v-if="viewData.textarea">
      {{ viewData.textarea }}
    </div>
    <div v-else>
      请输入文本提示内容
    </div>
  </div>
</template>
<script>
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
export default {
  name: 'SpActiveTextarea',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      inputVal: null,
      viewData: {
        textarea: '',
        margin: [0, 0, 0, 0]
      }
    }
  },
  mounted () {
    // console.log('spinput-viewData',this.viewData)
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.flex_box {
  width: 100%;
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
}
</style>
